import React from 'react';

export default function StatsBar({ stats }) {
  return (
    <div style={{
      maxWidth: 1200, margin: '0 auto 48px',
      padding: '0 24px',
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: 12,
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-xl)',
        padding: '20px 24px',
      }}>
        <StatItem value={stats.total_condos} label="Condos Tracked" />
        <Divider />
        <StatItem value={stats.total_complaints} label="Total Complaints" />
        <Divider />
        <StatItem value={stats.high_risk_count} label="High Risk" color="var(--risk-high)" />
        <Divider />
        <StatItem value={stats.medium_risk_count} label="Medium Risk" color="var(--risk-medium)" />
        <Divider />
        <StatItem value={stats.low_risk_count} label="Low Risk" color="var(--risk-low)" />
        <Divider />
        <StatItem value={stats.special_assessment_count} label="Special Assessments" color="var(--risk-high)" />
      </div>
    </div>
  );
}

function StatItem({ value, label, color }) {
  return (
    <div style={{ textAlign: 'center', padding: '4px 0' }}>
      <div style={{
        fontSize: 28, fontWeight: 300,
        fontFamily: 'var(--font-display)',
        color: color || 'var(--text-primary)',
        lineHeight: 1, marginBottom: 4,
      }}>
        {value}
      </div>
      <div style={{ fontSize: 11, color: 'var(--text-tertiary)', letterSpacing: 0.5, textTransform: 'uppercase', fontWeight: 500 }}>
        {label}
      </div>
    </div>
  );
}

function Divider() {
  return (
    <div style={{
      width: 1, height: 40,
      background: 'var(--border)', margin: 'auto',
    }} />
  );
}
